<template>
  <div class="product-channel-dialog">
    <el-dialog
      :visible="visible"
      title="订单属性要求设置"
      @close="handleCancel"
      :close-on-click-modal="false"
      :modal="false"
      width="70%"
    >
      <el-table :data="localList" border>
        <el-table-column
          prop="name"
          label="订单属性"
          align="center"
          min-width="120"
        />
        <el-table-column label="是否校验" align="center" min-width="100">
          <template v-slot="{ row }">
            <el-checkbox v-model="row.verification"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="包含订单属性值" align="center" min-width="200">
          <template v-slot="{ row }">
            <div v-if="row.code === 'leaveOrder' || row.code === 'repeatOrder'">
              <el-radio-group v-model="row.value" size="small">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
            <div v-else-if="row.code === 'customerExpectDeliveryTime'">
              <el-select v-model="row.value" filterable class="w-full">
                <el-option
                  v-for="item in allOptions.customerExpectDeliveryTime"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else-if="row.code === 'brandCategory'">
              <el-cascader
                :value="getBrandCategoryCascaderValue(row.value)"
                :options="allOptions.brandCategoryProps"
                :props="{
                  multiple: true,
                }"
                :collapse-tags="true"
                @change="(val) => handleBrandCategoryChange(val, row)"
                class="w-full"
              ></el-cascader>
            </div>
            <div v-else-if="row.code === 'physicalShopId'">
              <el-select
                v-model="row.value"
                multiple
                filterable
                collapse-tags
                class="w-full"
              >
                <el-option
                  v-for="item in allOptions.physicalShopList"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </div>
            <div v-else-if="row.code === 'productChannel'" collapse-tags>
              <div class="product-channel-setting-row">
                <span class="product-channel-label-ellipsis">
                  {{ productChannelLabel }}
                </span>
                <el-button
                  size="small"
                  type="text"
                  @click="productChannelDialogVisible = true"
                  :disabled="getIsDisabled()"
                  >设置</el-button
                >
              </div>
            </div>
            <div v-else-if="row.code === 'orderType'">
              <el-select
                v-model="row.value"
                multiple
                filterable
                collapse-tags
                class="w-full"
              >
                <el-option
                  v-for="item in allOptions.orderType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else-if="row.code === 'productType'">
              <el-select
                v-model="row.value"
                multiple
                filterable
                collapse-tags
                class="w-full"
                :disabled="getIsDisabled()"
              >
                <el-option
                  v-for="item in filterProductCategoryOptions"
                  :key="item.value"
                  :label="getProductCategoryLabel(item)"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else-if="row.code === 'designSource'">
              <el-select
                v-model="row.value"
                multiple
                filterable
                collapse-tags
                class="w-full"
              >
                <el-option
                  v-for="item in allOptions.orderDesignSource"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else>
              <span>未能匹配组件</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <ProductChannelDialog
      v-if="productChannelDialogVisible"
      :visible.sync="productChannelDialogVisible"
      :value="
        getOrderConditionByCode('productChannel', localList)
          ? getOrderConditionByCode('productChannel', localList).value
          : []
      "
      :brandCategoryValue="
        getOrderConditionByCode('brandCategory', localList)
          ? getOrderConditionByCode('brandCategory', localList).value
          : []
      "
      @confirm="handleProductChannelConfirm"
    />
  </div>
</template>

<script>
import { getDict } from "@oppein/op-utils";
import ProductChannelDialog from "./ProductChannelDialog.vue";
import { getDictLabelSync, reqGetCurrentUser } from "@oppein/op-utils";
import { getProductChannelList, getShopListByConToPost } from "@/api/reviewOrder/index.js";

export default {
  name: "OrderConditionDialog",
  components: { ProductChannelDialog },
  props: {
    visible: Boolean,
    value: Array, // 传入的 orderConditionList
  },
  data() {
    return {
      currentUserInfo: {},
      localList: [],
      allOptions: {
        physicalShopList: [], // 所属门店选项
        brand: [], // 品牌选项
        category: [], // 品类选项
        brandCategoryProps: [], // 品牌和品类的级联选择属性
        productChannel: [], // 产品渠道选项
        orderType: [], // 订单类型选项
        productCategory: [], // 产品类别选项
        orderDesignSource: [], // 订单设计来源选项
        // 客户期望交付时间选项
        customerExpectDeliveryTime: [
          { label: "一周内", value: 7 },
          { label: "两周内", value: 14 },
          { label: "三周内", value: 21 },
        ],
      },
      productChannelDialogVisible: false,
      getDictLabelSync,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.localList = JSON.parse(JSON.stringify(val || []));
      },
    },
  },
  computed: {
    /**
     * 获取产品渠道的标签
     * @returns {string} - 产品渠道的标签
     */
    productChannelLabel() {
      const coditionItem = this.getOrderConditionByCode(
        "productChannel",
        this.localList,
      );
      if (!coditionItem) {
        console.error("productChannel condition not found");
        return "";
      }
      const list = coditionItem.value;
      if (!list) return "";
      if (!Array.isArray(list) || !list.length) return "未设置产品渠道";
      const labelList = list.map((item) => {
        const findProductChannel = this.allOptions.productChannel.find(
          (channel) => channel.productChannelCode === item,
        );
        if (findProductChannel) {
          return `${findProductChannel.productChannelName}（${getDictLabelSync(findProductChannel.category, "ROOT_category")}）`;
        }
        return item;
      });
      return labelList.join("；");
    },
    /**
     * 过滤产品类别选项
     * @returns {Function} - 过滤函数
     */
    filterProductCategoryOptions() {
      const brandCategoryCond = this.getOrderConditionByCode(
        "brandCategory",
        this.localList,
      );

      if (!brandCategoryCond || !Array.isArray(brandCategoryCond.value))
        return this.allOptions.productCategory;

      return this.allOptions.productCategory.filter((item) => {
        const category = item.value.split("_").slice(0, -1).join("_");
        return brandCategoryCond.value.some(
          (brandCategory) => brandCategory.category === category,
        );
      });
    },
  },
  mounted() {
    this.getAllOptions();
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      this.$emit("update:visible", false);
      this.$emit("confirm", this.localList);
    },
    /**
     * 获取所有选项数据
     */
    async getAllOptions() {
      this.currentUserInfo = await reqGetCurrentUser();
      const promiseList = [
        getDict("ROOT_brand"),
        getDict("ROOT_category"),
        // getDict("ROOT_ProductChannel"),
        getProductChannelList(),
        getDict("ROOT_MTDS_order_type"),
        getDict("ROOT_product_category"),
        getDict("ROOT_MARKET_DESIGN_SOURCE_TYPE"),
        getShopListByConToPost({ orgId: this.currentUserInfo.orgId, shopIsPhysicalShop: 1 }),
      ];
      const results = await Promise.all(promiseList);
      this.allOptions.brand = results[0];
      this.allOptions.category = results[1];
      this.allOptions.productChannel = results[2].data || [];
      this.allOptions.orderType = results[3];
      this.allOptions.productCategory = results[4];
      this.allOptions.orderDesignSource = results[5];
      this.allOptions.physicalShopList = results[6].data || [];
      const leafCategory = this.allOptions.category.map((categoryItem) => ({
        value: categoryItem.value,
        label: categoryItem.label,
        leaf: true, // 假设品类是叶子节点
      }));
      this.allOptions.brandCategoryProps = this.allOptions.brand.map(
        (item) => ({
          value: item.value,
          label: item.label,
          children: leafCategory,
        }),
      );
    },
    /**
     * 处理品牌分类选择
     */
    handleBrandCategoryChange(val, row) {
      // val: 多选时为二维数组 [[brand, category], ...]
      if (Array.isArray(val) && val.length && Array.isArray(val[0])) {
        row.value = val.map((arr) => ({ brand: arr[0], category: arr[1] }));
      } else {
        row.value = [];
      }

      // 清除产品渠道选择以及产品类别选择
      const condition = this.getOrderConditionByCode(
        "productChannel",
        this.localList,
      );
      if (condition) {
        condition.value = [];
      }
      const productCategoryCondition = this.getOrderConditionByCode(
        "productType",
        this.localList,
      );
      if (productCategoryCondition) {
        productCategoryCondition.value = [];
      }
    },
    /**
     * 获取品牌分类级联选择的值
     * @param {Array} value - 可能是对象数组
     * @returns {Array} - 返回品牌和品类的二维字符串数组
     */
    getBrandCategoryCascaderValue(value) {
      // value: [{brand, category}, ...] => [[brand, category], ...]
      if (
        Array.isArray(value) &&
        value.length &&
        typeof value[0] === "object"
      ) {
        return value.map((obj) => [obj.brand, obj.category]);
      }
      return [];
    },
    /**
     * 处理产品渠道设置
     * @param {Array<string>} val - 选中的产品渠道值
     */
    handleProductChannelConfirm(val) {
      this.productChannelDialogVisible = false;
      const condition = this.getOrderConditionByCode(
        "productChannel",
        this.localList,
      );
      if (!condition)
        throw new Error("productChannel is not found in orderConditionList");
      condition.value = val;
    },
    /**
     * 通过code获取localList中的某一项
     * @param {string} code
     * @param {Array} list - localList
     * @returns {Object|null}
     */
    getOrderConditionByCode(code, list) {
      if (!Array.isArray(list)) return null;
      return list.find((item) => item.code === code) || null;
    },
    /**
     * 获取产品类别的标签
     * @param {Object} item - 产品类别对象
     * @returns {string} - 产品类别的标签
     */
    getProductCategoryLabel(item) {
      if (!item || !item.value) return "";
      const category = item.value.split("_").slice(0, -1).join("_");
      // 获取产品类别的标签
      return `${getDictLabelSync(item.value, "ROOT_product_category")}（${getDictLabelSync(category, "ROOT_category")}）`;
    },
    /**
     * 检查是否禁用选择
     * @returns {boolean} - 是否禁用
     */
    getIsDisabled() {
      return (
        !this.getOrderConditionByCode("brandCategory", this.localList) ||
        !this.getOrderConditionByCode("brandCategory", this.localList).value ||
        !this.getOrderConditionByCode("brandCategory", this.localList).value
          .length
      );
    },
  },
};
</script>

<style scoped lang="scss">
.product-channel-dialog {
  .w-full {
    width: 100%;
  }
  .product-channel-setting-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 32px;
    .product-channel-label-ellipsis {
      margin-right: 10px;
      display: -webkit-box;
      // max-width: 320px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>



// WEBPACK FOOTER //
// OrderConditionDialog.vue?3a7e33d2